import { SubjectData } from 'shell/models/person';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import {
  CancellationUnderage,
  UnderageForm,
} from 'cancellations/view-models/cancellation-underage';

const emptyUnderageForm: UnderageForm = {
  reason: '',
  date: null,
};

export const transformAnprResponse = (response: SubjectData[]): CancellationUnderage => {
  const responseToTransform = response || {};
  const subjectData = responseToTransform[0] || {};
  const personForm = transformPerson(subjectData);
  const familyCoexistence = transformFamilyCoexistence(subjectData);
  const citizenshipForm = transformCitizenship(subjectData);

  return {
    subjectData: {
      ...subjectData,
      matrimonio: {
        ...subjectData.matrimonio,
        coniuge: {
          ...subjectData.matrimonio?.coniuge,
        },
      },
    },
    person: personForm,
    citizenship: citizenshipForm,
    familyCoexistence,
    underageForm: emptyUnderageForm,
  };
};

export const transformAnprRequestDeath = (form: CancellationUnderage): unknown => {
  return {
    soggetto: form.subjectData,
    dataCancellazione: form.underageForm?.date?.toFormat('yyyy-MM-dd') || undefined,
    motivoCancellazione: form.underageForm?.reason || undefined,
  };
};
